var map = {
	"./Brasileirão.jpg": 945,
	"./Bundesliga.jpg": 983,
	"./La Liga.jpg": 844,
	"./Ligue 1.jpg": 765,
	"./NBA.jpg": 339,
	"./Nova Temporada.jpg": 544,
	"./Premier League.jpg": 374,
	"./Primeira Liga.jpg": 493,
	"./Seleções.jpg": 211,
	"./Serie A.jpg": 192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 130;